import { BrowserMultiFormatReader } from "@zxing/browser";

export const scanImeiFromImage = async (file) => {
  const reader = new BrowserMultiFormatReader();
  const url = URL.createObjectURL(file);

  try {
    const result = await reader.decodeFromImageUrl(url);
    const imei = result.getText().replace(/\D/g, "");

    if (imei.length < 14 || imei.length > 16) {
      throw new Error("Invalid IMEI");
    }

    return imei;
  } finally {
    URL.revokeObjectURL(url);
  }
};
